module.exports = __webpack_public_path__ + "b385831e3ed19aa2b059b254a028bf98.svg";